import { renderPage } from "renderPage"
import { AccountBoatShowPage } from "./Page"

renderPage({ component: AccountBoatShowPage })
